<template>
  <Container type="card-full">
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{project.projectcode}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{project.projectno}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{project.pcomfullname}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{project.projectname}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">总分计算方式</div>
            <div class="view-value">
              {{project.projectpgstotalrule === '1' ? '百分比' : '绝对值'}}
              <!--<el-radio v-model="project.projectpgstotalrule" label="2">分值</el-radio>-->
              <!--<el-radio v-model="project.projectpgstotalrule" label="1">权重制</el-radio>-->
            </div>
          </div>
          <div class="view-field">
            <div class="view-label">项目</div>
            <div class="view-value">
              {{parentModel.pgname}}
              <!--<el-radio v-model="project.projectpgstotalrule" label="2">分值</el-radio>-->
              <!--<el-radio v-model="project.projectpgstotalrule" label="1">权重制</el-radio>-->
            </div>
          </div>
          <div class="view-field">
            <div class="view-label">分值</div>
            <div class="view-value">
              {{parentModel.pgratio}}
              <!--<el-radio v-model="project.projectpgstotalrule" label="2">分值</el-radio>-->
              <!--<el-radio v-model="project.projectpgstotalrule" label="1">权重制</el-radio>-->
            </div>
          </div>
        </div>
        <div class="split-line"></div>
      </div>
    </div>
    <div class="container">
      <vgtree ref="xTree" class="vgtree" :list="leftTreeList" tableheight="500" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="false" :expandAll="true"
              @cellClick="cellClick">
        <template slot="btn">
          <!--<vxe-button @click="addPg">新增主项</vxe-button>-->
          <vxe-button @click="addChildPg">新增评分项</vxe-button>
          <vxe-button @click="delPg">删除</vxe-button>
        </template>
      </vgtree>
      <div class="content ss-fl">
        <el-form :model="pg" ref="ruleForm" class="mainfrom from_input">
          <el-form-item label="标识" prop="pgflg" verify :label-width="formLabelWidth">
            <div v-if="showPgflg && pg.pglevel === 1">
              <el-radio v-model="pg.pgflg" label="1">价格项</el-radio>
              <el-radio v-model="pg.pgflg" label="2">非价格</el-radio>
            </div>
            <div class="from-value" v-else>{{+pg.pgflg === 1 ? '价格项' : '非价格'}}</div>
          </el-form-item>
          <el-form-item label="上级" v-if="+pg.pgflg === 2" :label-width="formLabelWidth">
            <!--<div v-if="!pg.pgid || pg.pgisend === 1">-->
            <!--<el-cascader placeholder="无" @change="parentidsChange" :show-all-levels="true"-->
            <!--v-model="parentids"-->
            <!--:options="pgList"-->
            <!--:props="{ checkStrictly: true }"-->
            <!--clearable></el-cascader>-->
            <!--</div>-->
            <div class="from-value"> {{parentids.length ? parentname : '无'}}</div>
          </el-form-item>
          <el-form-item label="级别" v-if="+pg.pgflg === 2" :label-width="formLabelWidth">
            <div class="from-value">{{parentids.length+1}}</div>
          </el-form-item>
          <el-form-item label="是否末级" v-if="+pg.pgflg === 2">
            <div v-if="isEdit && ((!pg.pgid && pg.pglevel !== 3) || (!pg.children.length && pg.pglevel !==3))">
              <el-radio v-model="pg.pgisend" :label="1">是</el-radio>
              <el-radio v-model="pg.pgisend" :label="0">否</el-radio>
            </div>
            <div class="from-value" v-else>
              {{+pg.pgisend===1 ? '是' : '否'}}
            </div>
          </el-form-item>
          <div v-if="isEdit" >
          <el-form-item label="序号" prop="pgseq" verify :label-width="formLabelWidth">
            <el-input v-model="pg.pgseq" :maxlength="4" auto-complete="off"></el-input>
          </el-form-item>
          </div>
          <el-form-item v-if="!isEdit" label="序号">
            <div class="from-value">{{pg.pgseq}}</div>
          </el-form-item>
          <div v-if="isEdit" >
          <el-form-item label="项目" prop="pgname" :verify="validatePgName" :label-width="formLabelWidth">
            <el-input v-model="pg.pgname" :maxlength="60" show-word-limit auto-complete="off"></el-input>
          </el-form-item>
          </div>
          <el-form-item v-if="!isEdit" label="项目">
            <div class="from-value">{{pg.pgname}}</div>
          </el-form-item>
          <div v-if="isEdit">
            <div v-if="!parentids.length">
              <div v-if="+project.projectpgstotalrule === 1" class="input-append">
                <el-form-item label="百分比" prop="pgratio" :verify="validateratio" int :gt="0"
                              :label-width="formLabelWidth">
                  <el-input v-model="pg.pgratio" show-word-limit>
                    <template slot="append">({{leg_pgratio}})</template>
                  </el-input>
                </el-form-item>
              </div>
              <div v-if="+project.projectpgstotalrule === 2" class="input-append">
                <el-form-item label="绝对值" prop="pgratio" :verify="validateratio" int :gt="0" :lte="100"
                              :label-width="formLabelWidth">
                  <el-input v-model="pg.pgratio">
                    <template slot="append">({{leg_pgratio}})</template>
                  </el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div v-if="!isEdit">
            <div v-if="+project.projectpgstotalrule === 1" class="input-append">
              <el-form-item label="百分比">
                <div class="from-value">{{pg.pgratio}}</div>
              </el-form-item>
            </div>
            <div v-if="+project.projectpgstotalrule === 2" class="input-append">
              <el-form-item label="绝对值">
                <div class="from-value">{{pg.pgratio}}</div>
              </el-form-item>
            </div>
          </div>
          <div v-if="pg.pgisend || +pg.pgflg === 1">
            <!--:verify="validatescore"-->
            <el-form-item label="分值" prop="pgscore" :verify="validatescore" int :gt="0"
                          :label-width="formLabelWidth">
              <el-input v-model="pg.pgscore" show-word-limit>
                <!--<template slot="append">({{leg_score}})</template>-->
              </el-input>
            </el-form-item>
          </div>
          <div v-if="pg.pgisend">
          <el-form-item label="档次及依据" prop="pgremark" verify :label-width="formLabelWidth">
            <el-input v-model="pg.pgremark" :autosize="{ minRows: 5}" type="textarea" :maxlength="1024" show-word-limit></el-input>
          </el-form-item>
          </div>

          <el-form-item label="" v-if="+pg.pglevel !== 1" :label-width="formLabelWidth">
            <vxe-button @click="savePg">保存</vxe-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  // import utils from '../../assets/js/utils'
  import vgtree from '../common/vgtree1'
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'

  export default {
    name: 'projectSetScoringFrom',
    mixins: [common],
    props: {
      pgid: {},
      projectid: {}
    },
    data () {
      return {
        isEdit: false,
        treeList: [],
        showPgflg: true,
        leftTreeList: [],
        parentModel: {},
        list: [],
        pgParentModel: '',
        pgPreModel: '',
        parentids: '',
        pgList: [],
        project: {},
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: ''},
          {field: 'pgname', fieldtype: 'C', title: '项目', calculExpr: ''}
        ],
        query: {
          total: 0,
          currPage: 1,
          pageSize: 20
        },
        parentModel: {},
        model: {},
        pg: {},
        loading: true,
        formLabelWidth: '100px'
      }
    },
    async activated () {
      // await this.getModel()
      // await this.getPgFolderList()
      // await this.getPgTree()
      // if (!this.treeList.length) {
      //   this.addPg()
      // }
    },
    async created () {
      await this.getModel()
      await this.getPgFolderList()
      await this.getPgTree()
      if (!this.treeList.length) {
        // this.addPg()
      }
    },
    mounted () {
    },
    deactivated () {
      this.$destroy()
    },
    watch: {},
    components: {vgtree, vggrid},
    methods: {
      parentidsChange () {
        if (this.parentids.length === 2) {
          // this.pg.pgisend = 1
        }
      },
      validatePgName (rul, val, callback) {
        this.pg.pgname = _.trim(val)
        this.validateData('项目名称已存在', 'pgrec', 'pgprojectid', 'pgname', val, 'pgprojectid', this.project.projectid, callback)
      },
      validateData (msg, tablename, fieldid, checkfield, checkval, fieldkey1, fieldkeyval1, callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {
            tablename,
            fieldid,
            checkfield,
            checkval: this.pg[checkfield],
            id: this.pg.pgprojectid,
            fieldkey1,
            fieldkeyval1
          }
        }).then(res => {
          res === 1 ? callback(Error(msg)) : callback()
        })
      },
      validatescore (rule, val, callback) {
        if (Number(val) > 100) {
          callback(Error(`分值不能大于100分`))
          return
        } else {
          callback()
        }
      },
      validateratio (rule, val, callback) {
        if (this.alreadyTotal > 100) {
          if (+this.project.projectpgstotalrule === 1) {
            callback(Error('权重合计不能大于100'))
          } else {
            callback(Error('分值合计不能大于100'))
          }
          return
        } else {
          callback()
        }
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.$route.params.projectid ? this.$route.params.projectid : this.projectid}
        })
        this.project = res
      },
      async addPg () {
        if (!this.project.projectpgstotalrule) {
          this.$message.warning('请选择总分计算方式！')
          return
        }
        this.isEdit = true
        let maxSeq = 0
        this.pg = ''
        this.treeList.forEach(item => {
          if (item.pgseq > maxSeq) {
            maxSeq = item.pgseq
          }
        })
        maxSeq += 10
        this.parentids = ''
        this.pg = {
          pgid: 0,
          pglevel: 1,
          pgseq: maxSeq,
          pgparentid: '',
          pgflg: '',
          pgname: '',
          pgratio: '',
          pgscore: '',
          pgremark: '',
          pgisend: 0
        }
        if (!this.showPgflg) {
          this.pg.pgflg = '2'
        }
      },
      addChildPg () {
        if (!this.pg.pgid) {
          this.$message.warning('请选择主项添加子项！')
          return
        }
        if (+this.pg.pgisend === 1) {
          this.$message.warning('该项是末级不能添加子项！')
          return
        }
        if (+this.pg.pgflg === 1) {
          this.$message.warning('价格项不能新增子项！')
          return
        }
        this.isEdit = true
        let maxSeq = 0
        this.pg = ''
        this.treeList.forEach(item => {
          if (item.pgseq > maxSeq) {
            maxSeq = item.pgseq
          }
        })
        maxSeq += 10
        this.parentids = ''
        this.pg = {
          pgid: 0,
          pglevel: Number(this.model.pglevel) + 1,
          pgseq: maxSeq,
          pgparentid: this.model.pgid,
          pgparentname: this.model.pgname,
          pgflg: '2',
          pgname: '',
          pgratio: '',
          pgscore: '',
          pgremark: '',
          pgisend: 1,
          children: []
        }
        if (this.model.pgparentid) {
          this.parentids = [this.model.pgparentid, this.pg.pgparentid]
        } else {
          this.parentids = [this.pg.pgparentid]
        }
        if (!this.showPgflg) {
          this.pg.pgflg = '2'
        }
        if (+this.pg.pglevel === 3) {
          this.pg.pgisend = 1
        }
      },
      async getPgFolderList () {
        this.pgList = await request({
          url: '/xmgl/pg/getPgFolderList',
          method: "get",
          params: {projectid: this.$route.params.projectid ? this.$route.params.projectid : this.projectid}
        })
      },
      async delPg () {
        if (this.pg.pglevel === 1) {
          this.$message.warning('不能删除总分项！')
          return
        }
        if (this.pg.children.length) {
          this.$message.warning('该项有下级数据，不能删除，请先删除下级数据！')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: '/xmgl/pg/delPg',
            method: "post",
            data: {pgid: this.pg.pgid}
          })
          if (data.issuccess === 1) {
            this.getPgTree()
            this.$message.success('删除成功！')
            this.isEdit = true
            this.addPg()
            console.log(this.$refs.xTree.updateData())
            this.$refs.xTree.updateData()
          }
        })
      },
      async savePg () {
        console.log('-------this.pgname---------',this.pgname);
        if (!this.project.projectpgstotalrule) {
          this.$message.warning('请选择总分计算方式！')
          return
        }
        this.submitForm('ruleForm').then(async() => {
          // this.pg.insertRecords = this.$refs.xGrid.$refs.xGrid.getSelectRecords()
          this.pg.projectid = this.$route.params.projectid ? this.$route.params.projectid : this.projectid
          // if (this.parentids.length === 1) {
          //   this.pg.pgparentid = this.parentids[0]
          //   this.pg.pglevel = 2
          // } else if (this.parentids.length === 2) {
          //   this.pg.pgparentid = this.parentids[1]
          //   this.pg.pglevel = 3
          // } else if (this.parentids.length === 3) {
          //   return
          // }
          // if (!this.parentids.length) {
          //   this.pg.pglevel = 1
          //   this.pg.pgparentid = 0
          // }

          this.pg.projectpgstotalrule = this.project.projectpgstotalrule
          if(this.$route.params.activeName === 'pfxm_ps'){
             this.pg.pgtype = 1
          }
          else if(this.$route.params.activeName === 'pfxm_js'){
             this.pg.pgtype = 2
          }
          if (+this.pg.pgflg === 1) {
            this.pg.pgisend = 1
          }
          let res = await request({
            url: '/xmgl/pg/savePg',
            method: "post",
            data: this.pg
          })
          if (res.issuccess === -1) {
            this.$message.warning(res.msg)
          } else {
            this.$message.success('保存成功')
          }
          await this.getPgTree()
          await this.getPgFolderList()
          // this.close()
          // this.isEdit = true
          // await this.addPg()
        }).catch(() => {
        })
      },
      async cellClick (row) {
        this.model = row.row
        this.pg = row.row
        if (+this.model.pglevel === 1) {
          this.isEdit = false
        } else {
          this.isEdit = true
        }
        let list = this.list.filter(v => +v.pgid === +this.pg.pgparentid)
        if (list.length) {
          this.pgPreModel = list[0]
          if (+this.pg.pglevel === 2) {
            this.parentids = [this.pgPreModel.pgid]
          } else if (+this.pg.pglevel === 3) {
            this.parentids = [this.pgPreModel.pgparentid, this.pgPreModel.pgid]
          }
        } else {
          this.pgPreModel = ''
          this.parentids = ''
        }

      },
      async getPgTree () {
        let pgname = ''
        if (this.$route.params.activeName === 'pfxm_ps') {
          pgname = '评审'
        } else if (this.$route.params.activeName === 'pfxm_js') {
          pgname = '技术'
        }
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/pg/getPgTree',
          params: {projectid: this.$route.params.projectid ? this.$route.params.projectid : this.projectid}
        })
        // 树状数据
        this.treeList = res.list

        this.parentModel = this.treeList.find(v => v.pgname === pgname)
        // this.pg = leftTreeModel
        // this.model = leftTreeModel
        this.leftTreeList = this.treeList.filter(v => v.pgname === pgname)
        // 明细数据
        this.list = res.data
        this.loading = false
        if (this.treeList.findIndex(v => +v.pgflg === 1) > -1) {
          this.showPgflg = false
        } else {
          this.showPgflg = true
        }
        if (this.leftTreeList.length) {
          this.cellClick({row: this.leftTreeList[0]})
          this.$refs.xTree.$refs.xTree.setCurrentRow(this.leftTreeList[0])
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      }
    },
    filters: {},
    computed: {
      parentname () {
        let pgname = ''
        for (let i = 0; i < this.parentids.length; i++) {
          let model = this.list.find(v => +v.pgid === this.parentids[i])
          if (model) {
            pgname = model.pgname
          }
        }
        return pgname
      },
      // 返回：绝对值/百分比的总分
      alreadyTotal () {
        let total = this.treeList.length ? this.treeList.map(t => Number(t.pgratio)).reduce((a, b) => a + b) : 0
        if (!this.pg.pgid) {
          total = total + Number(this.pg.pgratio)
        }
        return total
      },
      // 返回：已分配分值/权重的合计分
      allowratio () {
        return 100 - Number(this.alreadyTotal ? this.alreadyTotal : 0)
      },
      // 返回：已分配分值/权重的合计分提示语
      leg_pgratio () {
        if (+this.project.projectpgstotalrule === 1) {
          if (this.allowratio >= 0) {
            return `权重已分配${this.alreadyTotal},可分配${this.allowratio}`
          } else {
            let allowRatio = 100 - (this.alreadyTotal - Number(this.pg.pgratio))
            if (allowRatio < 0 || Number(this.pg.pgratio) > allowRatio) {
              allowRatio = 0
            }
            return `权重已分配${this.alreadyTotal},可分配${allowRatio}`
          }
        } else {
          if (this.allowratio >= 0) {
            return `总分值已分配${this.alreadyTotal}分,可分配${this.allowratio}分`
          } else {
            let allowRatio = 100 - (this.alreadyTotal - Number(this.pg.pgratio))
            if (allowRatio < 0 || Number(this.pg.pgratio) > allowRatio) {
              allowRatio = 0
            }
            return `总分值已分配${this.alreadyTotal},可分配${allowRatio}分`
          }
        }
      },
      // 返回:计算方式为分值时,当前节点的项目分值
      currentScoreTotal () {
        let pgratio = 0
        if (+this.pg.pgflg === 1 || this.parentids.length) {
          let pgid = +this.pg.pgflg === 1 ? this.pg.pgid : this.parentids[0]
          let model = this.treeList.find(v => +v.pgid === +pgid)
          if (model) {
            pgratio = model.pgratio
          } else {
            pgratio = this.pg.pgratio
          }
        } else {
          pgratio = this.model.pgratio
        }
        return Number(pgratio)
      },
      // 返回:计算方式为分值时,当前节点的已分配分值
      cAlreadyScoreTotal () {
        if (this.parentids.length) {
          let pgparentid = ''
          if (this.parentids.length === 2) {
            pgparentid = this.parentids[1]
          } else if (this.parentids.length === 1) {
            pgparentid = this.parentids[0]
          }
          let list = []
          if (this.pg.pgid) {
            list = this.list.filter(v => +v.pgisend === 1 && +v.pgparentid === +pgparentid && v.pgid !== this.pg.pgid)
          } else {
            list = this.list.filter(v => +v.pgisend === 1)
          }

          let pgscoretotal = list.length ? list.map(t => Number(t.pgscore)).reduce((a, b) => a + b) : 0
          pgscoretotal = pgscoretotal + Number(this.pg.pgscore)
          return pgscoretotal
        } else {
          return Number(this.pg.pgscore)
        }
      },
      // 返回:计算方式为分值时,当前节点的可分配分值
      currentAllowScoreTotal () {
        return this.currentScoreTotal - this.cAlreadyScoreTotal
      },
      // 返回：计算方式为分值时,分配分值提示语
      leg_score () {
        if (this.currentAllowScoreTotal >= 0) {
          return `该项分值为${this.currentScoreTotal}分,已分配${this.cAlreadyScoreTotal}分,可分配${this.currentAllowScoreTotal}分`
        } else {
          let allowScore = this.currentScoreTotal - (this.cAlreadyScoreTotal - Number(this.pg.pgscore))
          if (allowScore < 0) {
            allowScore = 0
          }
          return `该项分值为${this.currentScoreTotal}分,可分配${allowScore}分`
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .container {
    display: flex;

    .from_input .el-input, .el-input .el-input__inner, .el-cascader {
      width: 380px;
    }
    .content .el-textarea__inner, .el-textarea {
      width: 380px;
    }

    .vgtree {
      border: 1px solid #d1dbe5;
      width: 35%;
      margin-right: 20px;
    }
    .vggrid {
      margin-left: 50px;
      width: 65%;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
    .pgright {
      border: solid;
      border: 1px solid #EBEEF5;
      width: 100%;
    }
  }
</style>
